import { createSelector } from 'reselect';
const getAuthFormStep = (state) => state.authForm.step;
export const makeGetAuthFormStep = () => createSelector(getAuthFormStep, (step) => step);
